import React, { useState } from 'react'

import { useEventOutside } from '@smarty-nx/code-utils'
import cn from 'classnames'

import { Icon } from '../../../../components'
import MenuItem from '../../menu-item'
import commonClasses from '../../menu-item/menu-item.module.scss'
import classes from '../MobileMenu.module.scss'
import { MobileMenuItem } from '../MobileMenu.types'

interface MobileMenuGroupItemProps {
  menuItem: MobileMenuItem
}

const MobileMenuGroupItem = ({ menuItem }: MobileMenuGroupItemProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const closeSubMenu = () => {
    setIsOpen(false)
  }
  const ref = useEventOutside(closeSubMenu)

  return (
    <div ref={ref}>
      <div
        className={cn(
          commonClasses.item,
          classes.groupMenu,
          isOpen ? classes.groupOpen : classes.groupClosed
        )}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {menuItem.label}
        <Icon name="chevron" />
      </div>
      {isOpen && (
        <div className={classes.subMenu}>
          {menuItem.items?.map((item) => (
            <MenuItem
              key={item.id}
              menuItem={item}
              className={cn(commonClasses.item, classes.menuItem)}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default MobileMenuGroupItem
